import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const editUser = (tokens: any, reqBody: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.editUser,
    method: 'POST',
    cache: false,
    body: reqBody,
  }
  return executeRequest(request).then(({ data }) => {
    return data?.data
  })
}

export { editUser }
